import { Box } from "@mui/material"
import type { Row } from "@tanstack/react-table"
import type { ReactElement } from "react"
import { useShallow } from "zustand/shallow"

import { UOM_RENDER_PRECISION, UOM_ROUNDING_PRECISION } from "@/constants/formats"
import { type OrderLine } from "@/graphql/codegen/graphql"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"
import { convertUoMQuantity } from "@/utils/conversion"
import { formatNumber } from "@/utils/number"

export const PriceUomColumnReadOnly = ({ row }: { row: Row<OrderLine> }): ReactElement => {
  const { pricePerUom, priceUomId, quantityInUom, uomId, product } = row.original

  const uoms = useUnitOfMeasurementsStore(useShallow((s) => s.units))
  const uom = uoms.find((uom) => uom.id === uomId)
  const priceUom = uoms.find((uom) => uom.id === priceUomId)

  const convertedUoMValue = convertUoMQuantity(quantityInUom, uomId, product, "package")
  const convertedUom = uoms.find((uom) => uom.id === convertedUoMValue.uomId)

  return (
    <Box>
      <Box className='flex gap-2'>
        <Box className='font-bold'>
          {pricePerUom ? (
            <>
              ${formatNumber(pricePerUom, UOM_ROUNDING_PRECISION)} / {priceUom?.name}
            </>
          ) : (
            <span>Not calculated</span>
          )}
        </Box>
      </Box>
      <Box className='flex gap-2'>
        <Box className='font-bold'>
          {formatNumber(quantityInUom, UOM_RENDER_PRECISION)} {uom?.name}
        </Box>
        <Box>
          ({formatNumber(convertedUoMValue.amount, UOM_RENDER_PRECISION)} {convertedUom?.name})
        </Box>
      </Box>
    </Box>
  )
}
